<template>
  <div>
    <div class="navbar-container">
      <div class="navbar-header-container">
        <b-navbar type="dark" class="navbar-wrapper">
          <b-navbar-nav class="brand-container">
            <b-navbar-brand class="brand" href="#" @click="toHome()">
              <img
                src="../../../assets/img/isupplier-logo.png"
                class="img-logo"
                alt=""
              />
            </b-navbar-brand>
          </b-navbar-nav>
          <div
            class="navbar-category cursor-pointer popup-category"
            @click="categoryToogle"
            @mouseenter="overlayOn"
          >
            Kategori <span><i class="fas fa-caret-down ml5"></i></span>
            <ModalCategory />
          </div>

          <div class="navbar-search">
            <input
              class="navbar-search-input"
              placeholder="Cari nama vendor / Kode KBLI disini ..."
              v-model="vendorName"
              @keydown="enterForSearch"
            />
            <div class="navbar-search-icon" @click="onSearch">
              <img
                :src="require('~/assets/img/icons/icon-search.png')"
                alt=""
              />
            </div>
          </div>
          <div
            class="navbar-advance-search cursor-pointer"
            @click="openAdvanceSearch"
          >
            <img
              :src="require('~/assets/img/icons/advance-search.png')"
              alt=""
            />
            Advance Search
          </div>
          <!-- Req Vendor & Profile -->
          <div
            class="navbar-profile-icon cursor-pointer"
            @click="openProfile"
            ref="profileMenu"
          >
            <img :src="require('~/assets/img/icons/power.png')" alt="" />
          </div>
          <div v-if="profileMenu" class="dropdown-request-vendor">
            <button class="btn-request-vendor" @click="openReqVendor">
              <svg
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.75008 9.49284H4.33341C3.8667 9.49284 3.63335 9.49284 3.45509 9.58367C3.29829 9.66356 3.1708 9.79104 3.09091 9.94785C3.00008 10.1261 3.00008 10.3595 3.00008 10.8262V17.8262M14.2501 9.49284H16.6667C17.1335 9.49284 17.3668 9.49284 17.5451 9.58367C17.7019 9.66356 17.8294 9.79104 17.9093 9.94785C18.0001 10.1261 18.0001 10.3595 18.0001 10.8262V17.8262M14.2501 17.8262V5.49284C14.2501 4.55942 14.2501 4.09271 14.0684 3.73619C13.9086 3.42258 13.6537 3.16762 13.3401 3.00783C12.9835 2.82617 12.5168 2.82617 11.5834 2.82617H9.41675C8.48333 2.82617 8.01662 2.82617 7.6601 3.00783C7.34649 3.16762 7.09153 3.42258 6.93174 3.73619C6.75008 4.09271 6.75008 4.55942 6.75008 5.49284V17.8262M18.8334 17.8262H2.16675M9.66675 6.15951H11.3334M9.66675 9.49284H11.3334M9.66675 12.8262H11.3334"
                  stroke="#344054"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              Request Vendor Baru
            </button>
            <button class="btn-request-vendor" @click="openEditCarousel" v-if="$store.state.role_id == 1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                width="24"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                />
              </svg>

              Edit Carousel
            </button>
            <div class="profile-wrapper">
              <div>
                <p class="profile-info">
                  Login sebagai: <br />
                  <span class="nama-user">{{ $store.state.currentUser }}</span>
                </p>
              </div>
              <div>
                <button class="btn-logout" @click="logout">
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.3333 14.4928L17.5 10.3262M17.5 10.3262L13.3333 6.15951M17.5 10.3262H7.5M7.5 2.82617H6.5C5.09987 2.82617 4.3998 2.82617 3.86502 3.09866C3.39462 3.33834 3.01217 3.72079 2.77248 4.1912C2.5 4.72597 2.5 5.42604 2.5 6.82617V13.8262C2.5 15.2263 2.5 15.9264 2.77248 16.4611C3.01217 16.9316 3.39462 17.314 3.86502 17.5537C4.3998 17.8262 5.09987 17.8262 6.5 17.8262H7.5"
                      stroke="#ED1D24"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Logout
                </button>
              </div>
            </div>
          </div>
          <!-- <div class="navbar-profile-icon cursor-pointer" @click="logout">
          <img :src="require('~/assets/img/icons/power.png')" alt="" />
        </div> -->
          <div class="navbar-mobile-menu" @click="openAdvanceSearch">
            <img :src="require('~/assets/img/icons/menu-icon.png')" alt="" />
          </div>
        </b-navbar>
      </div>
    </div>
    <ModalVendorReq
      v-if="$store.state.modalStore.modalTicketNewVendor"
      @closeReqVendor="closeReqVendor"
    />
    <div v-if="editCarousel">
      <modal-carousel
        :images="slides"
        @closeModalCarousel="closeEditCarousel"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { api } from '@/services/config'
export default {
  name: 'Navbar',
  components: {
    ModalCategory: () => import('@/components/Modal/Category'),
    ModalVendorReq: () => import('@/components/ModalReqVendor'),
    ModalCarousel: () => import('@/components/ModalCarousel.vue'),
  },
  data() {
    return {
      search: '',
      advanceSearchStatus: false,
      profileMenu: false,
      vendorReq: false,
      editCarousel: false,
      // vendorName: '',
    }
  },
  created() {
    this.getK3lCriteria()
    this.getKplhCriteria()
  },
  mounted() {
    this.$nextTick(() => {
      document.body.addEventListener('click', this.handleBodyClick)
    })
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.handleBodyClick)
  },

  computed: {
    vendorName: {
      get: function() {
        return this.$store.state.searchStore.vendorName
      },
      set: function(newValue) {
        this.$store.commit('searchStore/SET_SEARCH_VALUE', {
          name: 'vendorName',
          value: newValue,
        })
      },
    },
    slides() {
      const slides = this.$store.state.slides
      console.log(slides)
      return slides
    },
  },
  methods: {
    handleBodyClick(event) {
      if (this.profileMenu && !this.$refs.profileMenu.contains(event.target)) {
        this.profileMenu = false
      }
    },
    overlayOn() {
      console.log('hover')
      this.$store.commit('setData', {
        name: 'overlayOpacity',
        value: 1,
      })
    },
    openProfile() {
      if (this.profileMenu) {
        this.profileMenu = false
        return
      }
      this.profileMenu = true
    },
    openAdvanceSearch() {
      this.$store.commit('modalStore/openModal', {
        name: 'advanceSearch',
      })
    },
    openEditCarousel() {
      this.editCarousel = true
    },
    closeEditCarousel() {
      this.editCarousel = false
    },
    openReqVendor() {
      this.$store.commit('modalStore/setValue', {
        name: 'modalTicketNewVendor',
        value: true,
      })
      this.profileMenu = false
    },
    closeReqVendor() {
      this.$store.commit('modalStore/setValue', {
        name: 'modalTicketNewVendor',
        value: false,
      })
    },
    toHome() {
      this.vendorName = ''
      const current = this.$router.currentRoute.path
      this.$store.commit('searchStore/RESET_FILTER_VALUE')
      this.$store.commit('level1/RESET_QUERY_VALUE')
      if (current != '/') {
        this.$router.push('/')
      }
    },
    enterForSearch(event) {
      if (event.which === 13) {
        this.onSearch()
      }
    },
    async onSearch() {
      const vendorName =
        this.vendorName !== '' || this.vendorName
          ? `&search=${this.vendorName}`
          : ''

      await this.$store.commit('level1/GET_VENDOR', {
        query: { vendorName },
      })
      if (this.$route.path !== '/search-result') {
        await this.$router.push({ path: '/search-result' })
      }
    },
    categoryToogle() {
      const isModalOpen = this.$store.state.modalStore.category

      if (!isModalOpen) {
        this.$store.commit('modalStore/openModal', {
          name: 'category',
        })
      } else {
        this.$store.commit('modalStore/closeModal', {
          name: 'category',
        })
      }
    },
    async getK3lCriteria() {
      try {
        const urlK3l = `${api}/api/v1/k3l-categories?page=1&limit=50`

        const { data: k3l } = await axios({
          method: 'GET',
          url: urlK3l,
        })

        console.log('k3l: ', k3l.data)
        this.$store.commit('setData', {
          name: 'k3lCategories',
          value: k3l.data,
        })
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async getKplhCriteria() {
      try {
        const urlKplh = `${api}/api/v1/kplh-categories?page=1&limit=50`

        const { data: kplh } = await axios({
          method: 'GET',
          url: urlKplh,
        })

        console.log('kplh: ', kplh.data)
        this.$store.commit('setData', {
          name: 'kplhCategories',
          value: kplh.data,
        })
      } catch (error) {
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
      }
    },
    async logout() {
      await this.$store.dispatch('logout')
      await this.$store.commit('AUTO_LOGIN')
    },
  },
}
</script>
